// extracted by mini-css-extract-plugin
export default {"regimen-finder":"RegimenFinder-module__regimen-finder--Em3n3"};